import React, { useState, createContext } from 'react';

export const StemCountsContext = createContext();

export const StemCountsProvider = (props) => {
  const [stemCountsDocs, setTermDocs] = useState([]);
  return (
    <StemCountsContext.Provider value={[stemCountsDocs, setTermDocs]}>{props.children}</StemCountsContext.Provider>
  );
};
